import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  width: ${({ size }) => size || 24}px;
  height: ${({ size }) => size || 24}px;
  border: 2px solid ${({ theme }) => theme.colors.dark.border};
  border-top: 2px solid ${({ theme }) => theme.colors.primary[500]};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingSpinner = ({ size }) => {
  return <Spinner size={size} />;
};

export default LoadingSpinner;
